query FacebookPublisherParams($campaignId: ID!) {
    facebookPublisherParams(campaignId: $campaignId) {
        businessPages {
            id
            name
        }
        campaigns {
            id
            name
        }
        adSets {
            id
            name
            campaignId
        }
    }
}
